/**
 * Apply a manifest-declared `hostCleanup.removeClasses` directive to the host
 * document (light DOM). This restores the behaviour of inline cleanup scripts
 * that legacy templates used to ship — most importantly Fetch's Shopify-page
 * embed, where the storefront wraps article bodies in
 * `<div class="reading-width article-content">` (max-width: 768px) and the
 * landing has to escape that wrapper to render at its native width.
 *
 * Idempotent and safe to call once per mount. No-op when `classes` is empty.
 */

export function applyHostCleanup(classes: string[] | undefined): void {
  if (!classes || classes.length === 0) return
  const selector = classes.map(c => `.${cssEscape(c)}`).join(',')
  for (const el of document.querySelectorAll(selector)) {
    el.classList.remove(...classes)
  }
}

function cssEscape(s: string): string {
  // Prefer CSS.escape when present (every evergreen browser). Otherwise quote
  // the class with a safe attribute selector fallback — the templates only
  // ever ship simple [a-zA-Z0-9_-] class names anyway, so this is belt-and-
  // suspenders for older runtimes / SSR test environments.
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(s)
  return s.replace(/[^\w-]/g, '\\$&')
}
